import Item from './Item'
import TabNavigatorElement from './TabNavigator'

import './style/css'

const TabNavigator = Object.assign(TabNavigatorElement, { Item })

export default TabNavigator
